<template>
  <v-form-group :validator="validator" :label="label">
    <div slot="toggle-icon" class="password-toggle">
      <svg-icon 
        :name="showPassword ? 'eye-closed' : 'eye'" 
        @click="showPassword = !showPassword" 
      />
    </div>
    <b-form-input 
      slot-scope="{ attrs }"
      :placeholder="placeholder" 
      v-model="input" 
      :class="inputClass(attrs)"
      :type="showPassword ? 'text' : 'password'" 
      autocomplete="new-password" 
    />
  </v-form-group>
</template>

<script>
export default {
    props: {
      value: {
        type: String
      },
      placeholder: {
        type: String,
        default: 'Enter password'
      },
      validator: {
        type: Object
      },
      label: {
        type: String
      }
    },

    watch: {
      input() {
        this.$emit('input', this.input);
      }
    },

    methods: {
      inputClass(attrs) { 
        return attrs?.state === false ? 'is-invalid': '';
      }
    },

    data() {
      return {
        input: this.value,
        showPassword: false
      }
    }
}
</script>